import React from 'react';

import ConfirmModal from '../ConfirmModal';

const DeleteReportConfirmModal = props => {
  const { t, visible, onCancel, onConfirm, ...rest } = props;

  return (
    <ConfirmModal
      {...rest}
      visible={visible}
      title={t('deleteReport')}
      okText={t('yes')}
      onOk={onConfirm}
      onCancel={onCancel}
      message={
        <div>
          <span>{t('areYouSureDeleteReport')}</span>
          <br />
          <span>{t('noteDeleteReport')}</span>
        </div>
      }
    />
  );
};

export default DeleteReportConfirmModal;
